export default "__VITE_ASSET__DfQYfTZf__"